import createIcon from '../../createIcon';

/**
 * @component @name Wifi1Bar
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuNTMwMiAxMC45NkwxMi4wMDAyIDE0LjVMOC40NzAyMSAxMC45NkM5LjM3MDIxIDEwLjA2IDEwLjYyMDIgOS41IDEyLjAwMDIgOS41QzEzLjM4MDIgOS41IDE0LjYzMDIgMTAuMDYgMTUuNTMwMiAxMC45NloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Wifi1Bar = createIcon('Wifi1Bar', [
  [
    'path',
    {
      d: 'M15.5302 10.96L12.0002 14.5L8.47021 10.96C9.37021 10.06 10.6202 9.5 12.0002 9.5C13.3802 9.5 14.6302 10.06 15.5302 10.96Z',
      key: '12u8rr',
    },
  ],
]);

export default Wifi1Bar;
